module.exports = __webpack_public_path__ + "static/media/Events.cc9d9aeb.jpg";